import { Features } from '@ardoq/api-types';
import {
  type IndexRouteContent,
  type PathRouteContent,
  type RouteNode,
} from 'router/declarative/routeNode';
import { uriComponentParam } from 'router/declarative/paramRegistry';
import { AppModules } from '../appContainer/types';
import { composeBoundaries } from '../router/declarative/composeBoundaries';
import { fixedResourcePermissionBoundary } from '../router/declarative/declarativePermissionBoundary';
import { featureFlagBoundary } from '../router/declarative/featureFlagBoundary';
import { ENTITY_USAGE_SECTIONS } from './types';

const loadDetailsPage = async (): PathRouteContent =>
  (await import('./ComponentTypeDetailsPage')).ComponentTypeDetailsPage;

export const routes = {
  path: '/component-type-details',
  appModule: AppModules.COMPONENT_TYPE_DETAILS,
  children: [
    {
      path: { layout: true },
      content: composeBoundaries([
        fixedResourcePermissionBoundary(
          { pageName: 'Component Types' },
          'organization/manage_metamodel_constraints',
          'organization'
        ),
        featureFlagBoundary([Features.GLOBAL_COMPONENT_TYPES_BETA]),
      ]),
      children: [
        {
          path: '/:componentTypeId',
          searchParams: { query: uriComponentParam },
          children: [
            {
              path: { index: true },
              content: async (): IndexRouteContent =>
                (await import('./ComponentTypeDetailsPage'))
                  .ComponentTypeDetailsPage,
            },
            {
              path: '/workspaces',
              content: loadDetailsPage,
              children: [
                {
                  path: '/:usageWorkspaceId',
                  children: [{ path: '/styling' }, { path: '/fields' }],
                },
              ],
            },
            {
              path: '/variations',
              content: loadDetailsPage,
              children: [
                {
                  path: '/:variationKey',
                  children: [{ path: '/styling' }, { path: '/fields' }],
                },
              ],
            },
            ...ENTITY_USAGE_SECTIONS.map(section => ({
              path: `/${section}` as const,
              content: loadDetailsPage,
            })),
          ],
        },
      ],
    },
  ],
} as const satisfies RouteNode;
